export enum Theme {
  Christmas = 'CHRISTMAS',
}
